import {Component} from '@angular/core';
import {ActivatedRoute} from "@angular/router";
import {environment} from "../../../env/environment";

@Component({
  template: ''
})
export class ViewPageComponent {
  baseURL = environment.baseURL

  constructor(
    private route: ActivatedRoute
  ) {
    this.route.params.subscribe(value => {
      window.location.href = this.baseURL.magliveWeb + 'magazines/' + value.magazineId;
    });
  }
}
